import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/components/Programs/UpcomingEventsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestPrepAd"] */ "/vercel/path1/src/components/resources/TestPrepAd.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/styles/Home.module.css");
